import { BASE_API } from "../utils/constants";

export async function getSiteConfigApi() {
  try {
    const url = `${BASE_API}/api/site-config/`;
    const response = await fetch(url);
    const result = await response.json();
    return result;
  } catch (error) {
    throw error;
  }
}

export async function updateSiteConfigApi(data, token) {
  try {
    const formData = new FormData();
    if (data.logo) formData.append("logo", data.logo);
    if (data.site_name !== undefined) formData.append("site_name", data.site_name);
    if (data.yape_qr) formData.append("yape_qr", data.yape_qr);
    if (data.plin_qr) formData.append("plin_qr", data.plin_qr);
    if (data.developer_logo) formData.append("developer_logo", data.developer_logo);
    if (data.developer_name !== undefined)
      formData.append("developer_name", data.developer_name);
    if (data.show_extras !== undefined) formData.append("show_extras", data.show_extras);
    if (data.tips_enabled !== undefined) formData.append("tips_enabled", data.tips_enabled);
    if (data.show_offers !== undefined) formData.append("show_offers", data.show_offers);

    const url = `${BASE_API}/api/site-config/`;
    const params = {
      method: "PATCH",
      headers: {
        Authorization: `Bearer ${token}`,
      },
      body: formData,
    };

    const response = await fetch(url, params);
    if (!response.ok) {
      const errorBody = await response.text();
      throw new Error(`No se pudo actualizar la configuración: ${errorBody}`);
    }
    const result = await response.json();
    return result;
  } catch (error) {
    throw error;
  }
}
